export default "__VITE_ASSET__c1a10fc3__"